/**
 * VoiceNote: 음성 메모 / 통역 설정 패널
 *
 * 실제 SpeechRecognition은 useSpeechRecognition 훅(VideoPage)에서 관리.
 * 이 컴포넌트는 언어 선택 + STT 토글 UI만 담당.
 */
import React from 'react';
import { useAppSelector, useAppDispatch } from '@/store/hooks';
import { uiActions } from '@/store/slices/uiSlice';
import { voiceNoteActions } from '@/store/slices/voiceNoteSlice';
import { captionActions } from '@/store/slices/captionSlice';

const SUPPORTED_LANGUAGES = [
  { code: 'ko', label: '한국어' },
  { code: 'en', label: 'English' },
  { code: 'ja', label: '日本語' },
  { code: 'zh', label: '中文' },
  { code: 'ru', label: 'Русский' },
];

const VoiceNote: React.FC = () => {
  const dispatch = useAppDispatch();
  const ui = useAppSelector((s) => s.ui);
  const voiceNote = useAppSelector((s) => s.voiceNote);
  const caption = useAppSelector((s) => s.caption);

  const handleToggleSTT = () => {
    const next = !caption.isEnabled;
    dispatch(captionActions.setEnabled(next));
    dispatch(uiActions.setCaptionEnabled(next));
  };

  if (!ui.isVoiceNoteOpen) return null;

  return (
    <>
      <div
        className="rtcCustoms_voiceNote__backdrop"
        onClick={() => dispatch(uiActions.setVoiceNoteOpen(false))}
      />
      <div
        className="rtcCustoms_voiceNote__panel"
        onClick={(e) => e.stopPropagation()}
      >
        {/* 헤더 */}
        <div className="rtcCustoms_voiceNote__header">
          <span className="rtcCustoms_voiceNote__title">음성 메모 / 통역</span>
          <button
            type="button"
            onClick={() => dispatch(uiActions.setVoiceNoteOpen(false))}
            className="rtcCustoms_voiceNote__closeBtn"
          >
            ✕
          </button>
        </div>

        {/* 언어 선택 */}
        <div className="rtcCustoms_voiceNote__langSection">
          <div className="rtcCustoms_voiceNote__langLabel">인식 언어</div>
          <select
            value={voiceNote.language}
            onChange={(e) => dispatch(voiceNoteActions.setLanguage(e.target.value))}
            className="rtcCustoms_voiceNote__select"
          >
            {SUPPORTED_LANGUAGES.map((lang) => (
              <option key={lang.code} value={lang.code}>
                {lang.label}
              </option>
            ))}
          </select>
        </div>

        {/* STT 토글 버튼 */}
        <div className="rtcCustoms_voiceNote__btnCenter">
          <button
            type="button"
            onClick={handleToggleSTT}
            className={`rtcCustoms_voiceNote__recordBtn ${caption.isEnabled ? 'rtcCustoms_voiceNote__recordBtn--active' : 'rtcCustoms_voiceNote__recordBtn--inactive'}`}
          >
            {caption.isEnabled ? '⏹' : '🎤'}
          </button>
        </div>

        {caption.isEnabled && (
          <div className="rtcCustoms_voiceNote__statusMsg">
            음성 인식 중 — 자막에 표시됩니다
          </div>
        )}
      </div>
    </>
  );
};

export default VoiceNote;
